import React from 'react';

function PersonsTab({
  persons,
  companyLanguage,
  setEditingPerson,
  setPersonForm,
  setShowAddPersonModal,
  handleEditPerson,
  handleDeletePerson
}) {
  return (
    <div className="bg-white rounded-lg shadow-lg p-6 border border-brand-card animate-fade-in-up">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">{companyLanguage === 'ur' ? 'رابطہ' : 'Contact Persons'}</h2>
        <button
          onClick={() => {
            setEditingPerson(null);
            setPersonForm({ name: "", contactNumber: "" });
            setShowAddPersonModal(true);
          }}
          className="bg-brand-header hover:bg-emerald-800 text-white font-semibold px-4 py-2 rounded-lg transition-all transform hover:scale-105 hover:shadow-lg flex items-center gap-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          {companyLanguage === 'ur' ? 'شامل کریں' : 'Add Person'}
        </button>
      </div>

      {persons.length === 0 ? (
        <div className="text-center py-12">
          <svg className="w-16 h-16 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          <p className="text-gray-600 mb-4">{companyLanguage === 'ur' ? 'ابھی کچھ شامل نہیں کیا گیا' : 'No persons added yet.'}</p>
          <button
            onClick={() => {
              setEditingPerson(null);
              setPersonForm({ name: "", contactNumber: "" });
              setShowAddPersonModal(true);
            }}
            className="bg-brand-header hover:bg-emerald-800 text-white font-semibold px-4 py-2 rounded-lg transition-all transform hover:scale-105 hover:shadow-lg"
          >
            {companyLanguage === 'ur' ? 'پہلا شامل کریں' : 'Add Your First Person'}
          </button>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {persons.map((person, index) => (
            <div
              key={person._id || index}
              className="flex justify-between items-center p-4 bg-brand-background rounded-lg border border-brand-card hover:shadow-lg transition-all transform hover:-translate-y-1"
            >
              <div className="flex items-center gap-4">
                <div className="bg-brand-card rounded-full p-3">
                  <svg className="w-6 h-6 text-brand-header" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">{person.name}</h3>
                  <p className="text-gray-600 text-sm flex items-center gap-1">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    {person.contactNumber}
                  </p>
                </div>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => handleEditPerson(person)}
                  className="text-brand-header hover:text-emerald-800 font-semibold p-2 hover:bg-brand-card rounded transition-all"
                  title="Edit"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                  </svg>
                </button>
                <button
                  onClick={() => handleDeletePerson(person._id)}
                  className="text-red-600 hover:text-red-800 font-semibold p-2 hover:bg-red-50 rounded transition"
                  title="Delete"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default PersonsTab;


